import AdminEndpoints from './components/AdminEndpoints';
import * as t from './actionTypes';
import * as actions from './actions';

export { default as postRequest } from './sagas';
export { adminAppReducer } from './reducer';
export { t, actions };

export default AdminEndpoints;
